import React from 'react';
import { FormComponentBuilder } from '../index';
import { FormControlProps, FormElementControlPropsType } from '../control';

export interface FormStaticImageProps extends FormControlProps {
    src: string;
    height: string;
    width: string;
}

export default function FormStaticImage({ controlProps }: FormElementControlPropsType<FormStaticImageProps>) {
    if (!controlProps.src) {
        return null;
    }

    return (
        <img
            height={controlProps.height}
            width={controlProps.width}
            src={controlProps.src}
            className={controlProps.controlClass ?? undefined}
        />
    );
}

export class FormStaticImageBuilder extends FormComponentBuilder {
    prepareProps(): FormStaticImageProps {
        return {
            ...this.controlProps,
            src: this.elementProps.componentProps?.src ?? '',
            height: this.elementProps.componentProps?.height ?? 'auto',
            width: this.elementProps.componentProps?.width ?? 'auto',
        };
    }
}
